import React from 'react';
import { Col } from 'react-grid-system';
import Section from '../Section';
import Typeform from '../Typeform';

function TypeformSection(props) {
  return (
    <Section>
      <Col xs={12}>
        <Typeform {...props} />
      </Col>
    </Section>
  );
}

export default TypeformSection;
